<template>
  <span v-html="highlight(message)"></span>
</template>

<script>
import utils from "@/utils";

export default {
  name: "Chat",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  computed: {
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  methods: {
    DetectEmail(text) {
      if (text.length) {
        var matches = text.match(
          /[a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/g
        );
        if (matches) {
          matches.forEach((element) => {
            text = text.replace(
              element,
              `<span class='EmailDetect'> ${element} </span>`
            );
          });
        }
      }
      return text;
    },
    check_msg(item) {
      if (typeof item.content === "object") {
        return item.content.message || "< empty >";
      } else {
        return item.content || "< empty >";
      }
    },
    highlight(item) {
      let text = this.check_msg(item);
      if (item.sender_type === "bot") {
        text = this.translate(text) || text;
      }
      if (item.sender_type === "self") {
        text = this.DetectEmail(text);
        if (this.$store.state.store_config.store.store_id === "49") {
          text = this.translate(text) || text;
        }
      }

      text = utils.convertMardownToHTML(text);
      text = utils.CleanTextReceived(text);
      return text;
    },
    translate(steps) {
      if (steps.split(".")[0]) {
        const keys = steps.split(".");
        let result = this.store_config.i18n[this.$i18n.locale];
        for (let i = 0; i < keys.length; i++) {
          const element = keys[i];
          if (result[element]) result = result[element];
          else return null;
        }
        return result;
      }
    },
  },
};
</script>
<style>
.EmailDetect {
  color: #f05365;
}
</style>
